import { IUser } from '@/domain/common'

export const isFetching = (state: any, isFetching: boolean) => {
    state.isFetching = isFetching;
}

export const allUsers = (state: any, users: IUser[]) => {
    state.allUsers = users;
}

export const user = (state: any, user: IUser) => {
    state.user = user;
}

export const deactivatedUsers = (state: any, users: IUser[]) => {
    state.deactivatedUsers = users;
}
